import { useCallback } from "react";
import { useAppDispatch } from "../hooks";
import { visaCrud } from "../slices/visaSlice";

interface VisaTypeCrudProps {
  method: string;
  data: any;
  slug: string | null;
  query: string | null;
}

export const useVisaTypeRequest = () => {
  const dispatch = useAppDispatch();

  const visaTypeRequest = useCallback(async ({ method, data, slug, query }: VisaTypeCrudProps): Promise<any> => {
    const dispatchData = await dispatch(visaCrud({ method, data, slug, query }));
    return dispatchData;
  }, [dispatch]);

  return visaTypeRequest;
};
